"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _localization = require("@lt/localization");
var _ChevronDown = _interopRequireDefault(require("../../icons-react/rebrand/ChevronDown"));
var _hotel = require("../../proptypes/hotel");
var _AbstractDropdown = _interopRequireDefault(require("../AbstractDropdown"));
var _Button = _interopRequireDefault(require("../Button"));
var _HotelOffersList = _interopRequireDefault(require("./HotelOffersList"));
var _HotelOffersModal = _interopRequireDefault(require("./HotelOffersModal"));
var _userflow = require("../../utils/userflow");
var _excluded = ["offers", "isMobile", "label"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var HotelOffersDropdown = /*#__PURE__*/function (_React$PureComponent) {
  function HotelOffersDropdown(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, HotelOffersDropdown);
    _this = _callSuper(this, HotelOffersDropdown, [props]);
    _this.state = {
      isOpen: false
    };
    _this.ref = /*#__PURE__*/_react["default"].createRef();
    _this.handleClick = _this.handleClick.bind(_this);
    _this.closeDropdown = _this.closeDropdown.bind(_this);
    _this.closeMobilePopup = _this.closeMobilePopup.bind(_this);
    _this.openMobilePopup = _this.openMobilePopup.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(HotelOffersDropdown, _React$PureComponent);
  return (0, _createClass2["default"])(HotelOffersDropdown, [{
    key: "handleClick",
    value: function handleClick(offer) {
      var onItemClicked = this.props.onItemClicked;
      onItemClicked(offer);
      this.closeDropdown();
    }
  }, {
    key: "headRenderer",
    get: function get() {
      var _this2 = this;
      var label = this.props.label;
      return function () {
        return /*#__PURE__*/_react["default"].createElement("span", null, label, /*#__PURE__*/_react["default"].createElement(StyledChevronDownIcon, {
          $isOpen: _this2.isOpen
        }));
      };
    }
  }, {
    key: "dropdown",
    get: function get() {
      return (0, _get2["default"])(this, 'ref.current');
    }
  }, {
    key: "isOpen",
    get: function get() {
      var isMobile = this.props.isMobile;
      var isOpen = this.state.isOpen;
      if (isMobile) {
        return isOpen;
      }
      return this.dropdown && this.dropdown.isOpen;
    }
  }, {
    key: "closeDropdown",
    value: function closeDropdown() {
      var dropdown = this.dropdown;
      if (dropdown) {
        dropdown.toggle(false);
      }
    }
  }, {
    key: "closeMobilePopup",
    value: function closeMobilePopup() {
      this.setState({
        isOpen: false
      });
    }
  }, {
    key: "openMobilePopup",
    value: function openMobilePopup() {
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        offers = _this$props.offers,
        isMobile = _this$props.isMobile,
        label = _this$props.label,
        rest = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      if (isMobile) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          functional: true,
          onClick: this.openMobilePopup
        }, this.headRenderer()), /*#__PURE__*/_react["default"].createElement(_HotelOffersModal["default"], {
          offers: offers,
          onClick: this.handleClick,
          onClose: this.closeMobilePopup,
          open: this.isOpen
        }));
      }
      return /*#__PURE__*/_react["default"].createElement(StyledDropdown, (0, _extends2["default"])({}, rest, {
        ref: this.ref,
        autoOpen: false,
        autoClose: false,
        headRenderer: this.headRenderer,
        contentRenderer: function contentRenderer() {
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledDropdownHeader, null, (0, _userflow.makeHeaderTitle)(offers)), /*#__PURE__*/_react["default"].createElement(StyledHotelOffersList, {
            onClick: _this3.handleClick,
            offers: offers
          }));
        }
      }));
    }
  }]);
}(_react["default"].PureComponent);
HotelOffersDropdown.propTypes = {
  onItemClicked: _propTypes["default"].func.isRequired,
  label: _propTypes["default"].string,
  isMobile: _propTypes["default"].bool,
  offers: _propTypes["default"].arrayOf(_hotel.HotelOfferPropTypes).isRequired
};
HotelOffersDropdown.defaultProps = {
  label: _localization.i18n.t('hotel.offer.dropdown'),
  isMobile: false
};
var StyledDropdown = (0, _styledComponents["default"])(_AbstractDropdown["default"]).withConfig({
  displayName: "HotelOffersDropdown__StyledDropdown",
  componentId: "sc-13tq4uv-0"
})(["position:relative;", "{left:50%;z-index:20;margin-top:10px;position:absolute;background-color:var(--white);border-radius:var(--border-radius);transform:translateX(-50%);min-width:290px;box-shadow:var(--box-shadow);::before{border-bottom:10px solid var(--white);border-left:10px solid transparent;border-right:10px solid transparent;content:'';height:0;left:50%;margin-left:-10px;position:absolute;top:-10px;width:0;}}"], _AbstractDropdown["default"].StyledContentContainer);
var StyledDropdownHeader = _styledComponents["default"].div.withConfig({
  displayName: "HotelOffersDropdown__StyledDropdownHeader",
  componentId: "sc-13tq4uv-1"
})(["font-size:16px;font-style:normal;font-weight:500;line-height:20px;padding:13px 10px 4px;"]);
var StyledHotelOffersList = (0, _styledComponents["default"])(_HotelOffersList["default"]).withConfig({
  displayName: "HotelOffersDropdown__StyledHotelOffersList",
  componentId: "sc-13tq4uv-2"
})(["max-height:500px;overflow-y:auto;"]);
var StyledChevronDownIcon = (0, _styledComponents["default"])(_ChevronDown["default"]).withConfig({
  displayName: "HotelOffersDropdown__StyledChevronDownIcon",
  componentId: "sc-13tq4uv-3"
})(["margin-left:2px;height:8px;", " path{fill:var(--grey1);}"], function (_ref) {
  var $isOpen = _ref.$isOpen;
  return $isOpen && (0, _styledComponents.css)(["transform:rotate(180deg);"]);
});
var _default = exports["default"] = HotelOffersDropdown;